<template>
  <div>
    <div class="overlay" v-if="state.isMenuMobileShowing" @click="closeMobileNav"></div>
    <div id="sidenavMobile" class="sidenav">
      <div class="nav-user">
        <div class="nav-item-detail">
          <div class="primary">
            {{teamName}}
          </div>
          <div class="secondary">
            {{currentUser.name}}
          </div>
        </div>
      </div>
      <div class="navbar navbar-mobile" @click="onCloseOutSideArea">
        <ul class="nav navbar-nav">
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${teamName}/manage/advertising`">
              Home <span class="sr-only">(current)</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${teamName}/manage/channels`">
              Channels
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${teamName}/manage/ads-preset`">
              Ads
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${teamName}/manage/history`">
              History
            </router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="http://dev5.ndev.pw/byteark-firework-subscriber/">
              <i class="fas fa-info-circle mr-1"></i> How it works with player
            </a>
          </li>
        </ul>
      </div>
      <div class="navbar navbar-logout">
        <ul class="nav navbar-nav">
          <a class="nav-item" :href="`${baseURL}/accounts/logout?team=${teamName}`">
            <div class="nav-link">Logout from {{teamName}}</div>
          </a>
        </ul>
      </div>
    </div>
    <nav class="navbar navbar-expand-lg navbar-dark text-light bg-dark">
      <button class="navbar-toggler mr-4" type="button" @click.stop="openMobileNav()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <router-link  class="navbar-brand" :to="`/${teamName}`">
        <i class="fas fa-fire-alt icon"></i> ByteArk Firework
      </router-link>
      <div class="navbar-collapse collapse" id="navbarNav">
        <ul class="nav navbar-nav mr-auto">
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${teamName}/manage/advertising`">
              Home <span class="sr-only">(current)</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${teamName}/manage/channels`">
              Channels
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${teamName}/manage/ads-preset`">
              Ads
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="`/${teamName}/manage/history`">
              History
            </router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="http://dev5.ndev.pw/byteark-firework-subscriber/">
              <small><i class="fas fa-info-circle mr-1"></i> How it works</small>
            </a>
          </li>
        </ul>
        <ul class="nav navbar-nav ml-4">
          <li class="nav-item">
            <DropdownButton class="submenu-container float-right">
              <div slot="button">
                <div class="nav-link nav-user">
                  <div class="nav-item-detail">
                    <div class="primary">
                      {{teamName}}
                    </div>
                    <div class="secondary">
                      {{currentUser.name}}
                      <div class="action">
                        <i class="fas fa-angle-down ml-2"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <a class="dropdown-item"
                  :href="`${baseURL}/accounts/logout?team=${teamName}`">Logout from {{teamName}}</a>
              </div>
            </DropdownButton>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { logout } from '@/modules/api/Auth';
import DropdownButton from '@/components/elements/DropdownButton';

export default {
  data() {
    return {
      state: {
        isMenuMobileShowing: false,
      },
    };
  },
  components: {
    DropdownButton,
  },
  computed: {
    ...mapGetters(['currentUser', 'isLoading']),
    teamName() {
      return this.$route.params.teamName;
    },
    baseURL() {
      if (process.env.PROXY_SERVER_URL) {
        return process.env.PROXY_SERVER_URL;
      }

      return window.location.origin;
    },
  },
  methods: {
    openMobileNav() {
      this.state.isMenuMobileShowing = true;
      document.getElementById('sidenavMobile').style.width = '250px';
    },
    closeMobileNav() {
      this.state.isMenuMobileShowing = false;
      document.getElementById('sidenavMobile').style.width = '0px';
    },
    onCloseOutSideArea(event) {
      // if click on anything except the modal itself, close the modal
      if (event.target.closest('.navbar-mobile')) {
        this.closeMobileNav();
      }
    },
    async logout() {
      try {
        await logout(this.teamName);
        await this.$store.dispatch('destoryCurrentUser');
        this.$router.push('/');
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/themes/variables.scss';


.overlay {
  position: fixed;
  z-index: 101;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.nav-user {
  display: flex;
  flex-direction: row;
  padding-top: 0;
  padding-bottom: 0;

  // min-width: 120px;

  // every child div inside nav-user
  > div {
    display: flex;
    justify-content: space-between;
  }

  .nav-item-detail {
    flex-direction: column;
    align-items: flex-start;

    .primary {
      font-weight: bold;
      color: $gray-100;
      line-height: 1.1;
    }

    .secondary {
      display: flex;
      align-self: flex-start;
      width: 100%;
      justify-content: space-between;

      font-size: $font-size-sm * 0.85;
    }

  }

  .nav-item-action {
    align-item: flex-end;
    align-self: center;
  }
}

/* The side navigation menu */
.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 300;
  top: 0;
  left: 0;
  overflow-x: hidden;
  transition: 0.5s;

  display: flex;
  flex-direction: column;
  background-color: white;
  box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.2), 0px 16px 24px 2px rgba(0,0,0,0.14), 0px 6px 30px 5px rgba(0,0,0,0.12);

  .nav-user {
    padding: $spacer;
    border-bottom: 1px solid $gray-200;
    font-weight: bold;
    font-size: $font-size-lg;
    white-space: nowrap;

    .nav-item-detail {
      .primary {
        color: $secondary;
      }
    }
  }

  .navbar {
    padding: 0;
    padding-top: $spacer * 0.25;

    .navbar-nav {
      flex: 1;

      .nav-link {
        padding-left: $spacer;
        padding-right: $spacer;
        color: $body-color;
      }
    }
  }

  // .navbar-logout {
  //   margin-top: auto;
  //   position: fixed;
  //   bottom: 0;
  //   left: 0;
  //   width: 250px;
  //   border-top: 1px solid $gray-200;
  //   padding-top: 0;
  // }
}

/* Style page content - use this if you want to push the page content to the right when you open the side navigation */
#main {
  transition: margin-left .5s;
  padding: 20px;
}

/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */
@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}

@media (max-width: 991.98px) {
  .navbar {
    justify-content: flex-start;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/elements/NavBar.vue